import * as ArticleTypes from 'Flow2/components/Article/ArticleTypes/ArticleTypes';
import {
    faNewspaper, faUser, faCalendar, faImages, faArrowUp,
    faSort, faLaptop, faVideo, faBook, faGlobeEurope, faUsers,
    faFile, faMusic
} from '@fortawesome/free-solid-svg-icons';

class PageHelper {

    onPopUpClick = () => {
        let elements = document.getElementsByClassName("DropdownWithFadeBox");
        if (elements && elements.length) {
            for (let i = 0; i < elements.length; i++) {
                elements[i].click();
            }
        }
    }

    onPageClick = () => {
        let elements = document.getElementsByClassName("custom-dropdownbody");
        if (elements && elements.length) {
            for (let i = 0; i < elements.length; i++) {
                elements[i].style.display = "none";
            }
        }
    }

    onKeyPress = (elementId, callback) => () => {
        let el = document.getElementById(elementId);
        if (el) el.onkeypress = (e) => {
            if (e.key === ArticleTypes.ENTER && e.shiftKey) return;
            else if (e.key === ArticleTypes.ENTER) callback(el);
        }
    }

    getIcons = (icontype) => {
        if (icontype) {
            switch (icontype) {
                case 'faBook':
                    return faBook;
                case 'faCalendar':
                    return faCalendar;
                case 'faUser':
                    return faUser;
                case 'faLaptop':
                    return faLaptop;
                case 'faImages':
                    return faImages;
                case 'faVideo':
                    return faVideo;
                case 'faSort':
                    return faSort
                case 'faGlobeEurope':
                    return faGlobeEurope;
                case 'faUsers':
                    return faUsers;
                case 'faArrowUp':
                    return faArrowUp;
                case 'faMusic':
                    return faMusic;
                case 'faFile':
                    return faFile;
                default:
                    return;
            }
        }
    }
}
export default PageHelper = new PageHelper();